import React from 'react';
import { Stethoscope, Heart, Scale, Activity, Pill, Calendar } from 'lucide-react';

const services = [
  {
    title: 'Primary Care',
    description: 'Comprehensive health care for patients 18 years and older',
    icon: Stethoscope,
    bgColor: 'bg-blue-50',
    iconBg: 'bg-blue-100',
    iconColor: 'text-blue-600',
    hoverShadow: 'hover:shadow-blue-100'
  },
  {
    title: 'Preventive Care',
    description: 'Regular check-ups and screenings to maintain your health',
    icon: Heart,
    bgColor: 'bg-rose-50',
    iconBg: 'bg-rose-100',
    iconColor: 'text-rose-600',
    hoverShadow: 'hover:shadow-rose-100'
  },
  {
    title: 'Obesity Management',
    description: 'Specialized weight management and metabolic health programs',
    icon: Scale,
    bgColor: 'bg-emerald-50',
    iconBg: 'bg-emerald-100',
    iconColor: 'text-emerald-600',
    hoverShadow: 'hover:shadow-emerald-100'
  },
  {
    title: 'Chronic Disease Management',
    description: 'Ongoing care for diabetes, hypertension, and other conditions',
    icon: Activity,
    bgColor: 'bg-purple-50',
    iconBg: 'bg-purple-100',
    iconColor: 'text-purple-600',
    hoverShadow: 'hover:shadow-purple-100'
  },
  {
    title: 'Medication Management',
    description: 'Expert guidance on medications and prescriptions',
    icon: Pill,
    bgColor: 'bg-amber-50',
    iconBg: 'bg-amber-100',
    iconColor: 'text-amber-600',
    hoverShadow: 'hover:shadow-amber-100'
  },
  {
    title: 'Same-Day Appointments',
    description: 'Quick access to care when you need it most',
    icon: Calendar,
    bgColor: 'bg-teal-50',
    iconBg: 'bg-teal-100',
    iconColor: 'text-teal-600',
    hoverShadow: 'hover:shadow-teal-100'
  },
];

export default function Services() {
  return (
    <div 
      id="services" 
      className="py-24 bg-white"
      role="region"
      aria-labelledby="services-heading"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <h2 
            id="services-heading"
            className="text-3xl font-bold text-gray-900 sm:text-4xl"
          >
            Our Services
          </h2>
          <p className="mt-4 text-xl text-gray-600">
            Comprehensive healthcare services tailored to your needs
          </p>
        </div>
        <div 
          className="mt-20 grid grid-cols-1 gap-12 sm:grid-cols-2 lg:grid-cols-3"
          role="list"
          aria-label="List of medical services"
        >
          {services.map((service) => (
            <div 
              key={service.title}
              className="text-center"
              role="listitem"
            >
              <div className="relative">
                {service.icon && (
                  <service.icon 
                    className="h-12 w-12 text-primary-600 mx-auto" 
                    aria-hidden="true"
                  />
                )}
              </div>
              <h3 className="mt-6 text-xl font-medium text-gray-900">
                {service.title}
              </h3>
              <p className="mt-3 text-base text-gray-600">
                {service.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}